import { cn } from '@shared/utils';

interface MessageIndicatorProps {
  className?: string;
  active: boolean;
}

export const MessageIndicator = (props: MessageIndicatorProps) => {
  return (
    <div className={cn('menu-msg-animation', 'group flex h-20 w-20 items-center justify-center')}>
      <div className='relative'>
        <div className='h-4 w-5'>
          <svg width='20' height='14' viewBox='0 0 20 14' xmlns='http://www.w3.org/2000/svg'>
            <g
              className={cn(
                'fill-[#888] transition-colors duration-200 ease-in-out hover:fill-[#f2f2f2]',
                'group-hover:fill-[#f2f2f2]',
                props.active && 'fill-[#f2f2f2]',
              )}
            >
              <path d='M0 3.375v7.336l5.043-3.406z' />
              <path d='M19.25 10.711v-7.336l-5.043 3.93z' />
              <path d='M9.625 10.875l-3.352-2.612-6.273 4.237v1.5h19.25v-1.5l-6.273-4.237z' />
              <path d='M0 1.5l9.625 7.5 9.625-7.5v-1.5h-19.25z' />
              <path d='M19.044 3.375v7.336l-5.044-3.406z' />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};
